// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 22432, offsets 510162:510323. Structure and names inferred from code, not screenshots.

let n = ["/docs/", "/ultraspeed", "/console/", "/", "home"];
function usesPageBackground(e) {
  return n.some((t) => e.includes(t));
}
export { usesPageBackground };
